var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandPackageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0387 19.3305C16.3181 17.9498 20.2213 17.5356 24.5007 18.1799C20.5975 18.5941 15.8949 19.6067 12.1328 21.8159C13.4965 21.7699 17.1176 21.9079 18.7165 22C22.1494 20.4351 28.592 18.7322 34 20.8033L19.8451 0.874477C19.4219 0.322176 18.8575 0 18.2462 0C17.5878 0 17.0235 0.322176 16.6003 0.920502L12.1798 7.45607C11.8036 6.81172 11.1923 6.39749 10.5339 6.39749C9.92254 6.39749 9.35823 6.71967 8.98202 7.27197L0 20.251C2.25726 22 6.16044 21.2176 12.0387 19.3305ZM10.2047 8.51464C10.3458 8.28452 10.5339 8.19247 10.769 8.19247C11.0041 8.19247 11.2393 8.33054 11.3804 8.65272C11.4744 8.83682 11.8976 9.66527 11.8976 9.66527C11.9917 9.84937 12.0858 9.84937 12.2268 9.84937C12.3209 9.84937 12.462 9.80335 12.556 9.7113L17.6349 2.30126C17.7759 2.11715 17.964 1.97908 18.1521 1.97908C18.3402 1.97908 18.5754 2.11715 18.6694 2.30126L25.4412 11.8285C24.0775 11.3222 22.5726 11 21.3499 11C19.3748 11 17.3057 11.5983 14.8603 12.9331C13.3084 13.7615 11.8506 14.2218 10.5809 14.2218C9.3112 14.2218 8.13555 13.7615 7.14799 12.887L10.2047 8.51464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandPackageIcon);
export default __webpack_public_path__ + "static/media/land-package-icon.08a1c0aed57e9d19d24dfa0afc28d93d.svg";
export { ForwardRef as ReactComponent };